module.exports = {
    'payments.address.update': 'user/$1/address/$2',
    'payments.payment-sources.update': 'payments/users/$1/payment-sources',
    'payments.payment-sources.index': 'payments/users/$1/payment-sources',
};
